import consola from 'consola'

const logger = consola.withTag('nuxt:analytics')

export const logDebug = function (message) {
  logger.info(message)
}
